<template>
  <div class="add-pro-wrapper">
    <el-row>
      <el-col :span="12"><Title title="试用配置 (app_config)"></Title></el-col>
      <el-col :span="12">
        <div style="width:100%;height:60px;padding-right:15px;box-sizing:border-box" class="flex_rec">
          <el-button type="primary" @click="save">保存</el-button>
        </div>
      </el-col>
    </el-row>

    <div class="add-pro-content">
      <el-card class="box-card">
        <el-form :model="form" label-width="220px">
          <el-form-item label="启用设备试用 (trial_enabled)">
            <el-switch
              v-model="form.trial_enabled"
              :active-value="1"
              :inactive-value="0"
              active-color="#13ce66"
              inactive-color="#ff4949"
            />
          </el-form-item>

          <el-form-item label="试用总时长(秒) (trial_duration_sec)">
            <el-input-number v-model="form.trial_duration_sec" :min="3600" :max="31536000" :step="3600" />
            <span class="inline-tip">43200 秒 = 12 小时</span>
          </el-form-item>

          <el-form-item label="试用离线窗口(秒) (trial_offline_grace_sec)">
            <el-input-number v-model="form.trial_offline_grace_sec" :min="3600" :max="172800" :step="3600" />
            <span class="inline-tip">7200 秒 = 2 小时</span>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import Title from "./components/Title"
import apis from "@/api/index"

export default {
  name: "TrialConfig",
  components: { Title },
  data() {
    return {
      loading: false,
      form: {
        trial_enabled: 1,
        trial_duration_sec: 43200,
        trial_offline_grace_sec: 7200,
      },
    }
  },
  methods: {
    normalizeFormFromApi(data = {}) {
      this.form = {
        trial_enabled: Number(data.trial_enabled || 0) > 0 ? 1 : 0,
        trial_duration_sec: this.clampInt(data.trial_duration_sec, 43200, 3600, 31536000),
        trial_offline_grace_sec: this.clampInt(data.trial_offline_grace_sec, 7200, 3600, 172800),
      }
    },
    read() {
      this.loading = true
      apis.appconfig
        .read()
        .then((res) => {
          const data = res?.data?.data || {}
          this.normalizeFormFromApi(data)
        })
        .catch((err) => {
          this.$message({ message: String(err || "读取配置失败"), type: "error" })
        })
        .finally(() => {
          this.loading = false
        })
    },
    save() {
      const payload = {
        trial_enabled: Number(this.form.trial_enabled || 0) > 0 ? 1 : 0,
        trial_duration_sec: this.clampInt(this.form.trial_duration_sec, 43200, 3600, 31536000),
        trial_offline_grace_sec: this.clampInt(this.form.trial_offline_grace_sec, 7200, 3600, 172800),
      }
      apis.appconfig
        .update(payload)
        .then(() => {
          this.$message({ message: "保存成功", type: "success" })
          this.read()
        })
        .catch((err) => {
          this.$message({ message: String(err || "保存失败"), type: "error" })
        })
    },
    clampInt(value, defaultValue, min, max) {
      const num = Number(value)
      if (!Number.isFinite(num)) return defaultValue
      return Math.min(max, Math.max(min, Math.floor(num)))
    },
  },
  mounted() {
    this.read()
  },
}
</script>

<style lang="scss" scoped>
.add-pro-wrapper {
  .add-pro-content {
    box-sizing: border-box;
    width: 100%;
    padding: 15px;
  }
  .box-card {
    margin-bottom: 5px;
  }
  .inline-tip {
    margin-left: 10px;
    color: #909399;
    font-size: 12px;
  }
}
</style>
